/* eslint-disable */

export default {
    // 供应商申请账号信息
    supplierAccountInfoBO1: Object.freeze([
        { label: "供应商名称:", fieldName: "supName" },
        { label: "省市地区:", fieldName: "location" },
        { label: "是否三证合一:", fieldName: "isCredentialsName" },
        { label: "统一社会信用代码:", fieldName: "regNum" },
        { label: "登录账号:", fieldName: "userName" },
        // { label: "手机号:", fieldName: "registMobile" },
        { label: "营业执照号:", fieldName: "regNum" },
        { label: "组织机构代码:", fieldName: "orgCode" },
        { label: "组织机构代码证件有效期:", fieldName: "orgCredentialsValidDate" },
        { label: "税号:", fieldName: "taxCode" },
    ]),
    supplierAccountInfoBO2: Object.freeze([
        { label: "联系人:", fieldName: "contactName" },
        { label: "联系人固定电话:", fieldName: "contactTel" },
        { label: "联系人传真:", fieldName: "contactFax" },
        { label: "联系人手机:", fieldName: "contactMobile" },
        { label: "联系人邮箱:", fieldName: "contactEmail" },
        // { label: "省市地区:", fieldName: "location" },
        { label: "联系人身份证号/境外社保号:", fieldName: "contactIdcard" },
    ]),
    supplierAccountInfoBO3: Object.freeze([
        { label: "推荐单位:", fieldName: "recommendIndyName" },
    ]),
    // 供应商基本信息
    supplierBaseInfo1: Object.freeze([
        { label: "供应商名称:", fieldName: "supName" },
        { label: "简称:", fieldName: "supShort" },
        { label: "历史名称:", fieldName: "supHistoryName" },
        { label: "登记状态:", fieldName: "recordStatus", displaynone: false },
        { label: "经营状态:", fieldName: "businessStatus", displaynone: false },
        { label: "供应商类型:", fieldName: "supTypeNameComp" },
        { label: "是否为外贸供应商:", fieldName: "isOutSupComp" },
        { label: "是否为中交内部企业:", fieldName: "isInIndyComp" },
        { label: "是否三证合一:", fieldName: "isCredentialsName" },
        { label: "单位性质:", fieldName: "companyPropertyName" },
        { label: "统一社会信用代码:", fieldName: "regNum" },
        { label: "单位类别:", fieldName: "companyCategory" },
        // { label: "境外社保号:", fieldName: "abroadSocialSecurity" },
        { label: "营业执照号:", fieldName: "regNum" },
        { label: "组织机构代码:", fieldName: "orgCode" },
        // { label: "组织机构代码证件有效期:", fieldName: "orgCredentialsValidDate" },
        { label: "税号:", fieldName: "taxCode" },
        { label: "住所:", fieldName: "homeAddr" },
        { label: "办公地址:", fieldName: "officeAddr" },
        { label: "邮编:", fieldName: "post" },
        { label: "注册资本（万元）:", fieldName: "regCapl", slot: "regCapl" },
        { label: "币种:", fieldName: "moneyTypeName" },
        { label: "实收资本（万元）:", fieldName: "factCapl", slot: "factCapl" },
        { label: "公司类型:", fieldName: "companyTypeName" },
        { label: "经营范围:", fieldName: "busiScope" },
        { label: "成立时间:", fieldName: "foundTime" },
        { label: "营业期限:", fieldName: "businessValidDateStr" },
        {
            label: "组织架构及营销网络:",
            fieldName: "orgStructMarketNet"
        },
        { label: "所属集团公司名称:", fieldName: "belongCompanyName" },
        { label: "公司简介:", fieldName: "companyProfile" },
    ]),
    supplierBaseInfo2: Object.freeze([
        { label: "产能:", fieldName: "capacity" },
        { label: "工艺技术状况:", fieldName: "processTech" },
    ]),
    supplierBaseInfo3: Object.freeze([
        { label: "所销售产品的生产商名称:", fieldName: "producerName" },
        { label: "销售代理资格:", fieldName: "agentQualify" }
    ]),
    // 供应商联系信息
    supplierContact: Object.freeze([
        { label: "法人代表姓名:", fieldName: "legalContactName" },
        { label: "法人代表手机:", fieldName: "legalContactMobile" },
        { label: "法定代表固定电话:", fieldName: "legalContactTel" },
        { label: "法人代表身份证号/境外社保号:", fieldName: "legalContactIdcard" },
        { label: "法定代表人传真:", fieldName: "legalContactFax" },
        { label: "法定代表人邮箱:", fieldName: "legalContactEmail" },
        { label: "销售负责人:", fieldName: "salesHeaderName" },
        { label: "销售负责人手机:", fieldName: "salesHeaderMobile" },
        { label: "销售负责人固定电话:", fieldName: "salesHeaderTel" },
        { label: "销售负责人身份证号/境外社保号:", fieldName: "salesHeaderIdcard" },
        { label: "销售负责人传真:", fieldName: "salesHeaderFax" },
        { label: "销售负责人邮箱:", fieldName: "salesHeaderEmail" },
        { label: "公司网址:", fieldName: "website" }
    ]),
    //供应商常用联系人信息
    supplierCommonLinkInfo: Object.freeze([
        { label: "联系人:", prop: "commonContactName", align: "center" },
        { label: "联系人手机:", prop: "commonContactMobile", align: "center" },
        { label: "联系人固定电话:", prop: "commonContactTel", align: "center" },
        { label: "联系人传真:", prop: "commonContactFax", align: "center" },
        { label: "联系人E-mail:", prop: "commonContactEmail", align: "center" },
        { label: "服务范围:", prop: "serviceScope", align: "center" },
        { label: "是否默认联系人:", prop: "isDefaultFlagName" }
    ]),
    //财务信息
    financeInfo: Object.freeze([
        { label: "银行账号:", fieldName: "bankId" },
        { label: "开户银行:", fieldName: "bankName" }
    ]),

    //产品信息
    productInfo: Object.freeze([
        { label: "产品编码", prop: "matcateryCode", align: "center" },
        { label: "产品名称", prop: "matcateryName", align: "center" },
        { label: "产品商标", prop: "matTrademark", align: "center" },
        { label: "备注", prop: "prodinfoRemark", align: "center" }
    ]),

    //合作业绩
    cooperationPerformance: Object.freeze([
        { label: "合作企业:", fieldName: "cooperEnterprise", filedSpan: 24 },
        { label: "与中交合作业绩:", fieldName: "cooperPerformIccec", filedSpan: 24 },
        {
            label: "与同行业企业合作业绩:",
            fieldName: "cooperPerformSameInd",
            filedSpan: 24
        },
        { label: "备注:", fieldName: "remark", filedSpan: 24 }
    ]),
    //资质文件
    certificates: Object.freeze([
        { label: "附件名称", prop: "fileinfoTypeName", align: "center", slot: 'fileName' },
        // { label: "附件大小", prop: "fileSize", slot: "size", align: "center" },
        { label: "附件类型", prop: "fileTypeName", align: "center", slot: 'fileType' },
        { label: "文件", prop: "fileName", align: "center" },
        { label: "附件说明", prop: "fileDesc", align: "center" },
        { label: "操作", prop: "d", slot: "opp", align: "center" }
    ]),
    //审批记录、审批日志
    approvalRecord: Object.freeze([
        { label: "操作人", prop: "operatorName", align: "center" },
        { label: "所属单位", prop: "operatorUnitName", align: "center" },
        { label: "所属部门", prop: "operatorDeptName", align: "center" },
        { label: "操作类型", prop: "operResultTypestr", align: "center" },
        {
            label: "操作状态",
            prop: "operState",
            align: "center",
            formatter(row, column) {
                console.log(row);
                console.log(column);
                return row.operState === 1 ? "已操作" : "未操作";
            }
        },
        { label: "操作时间", prop: "operTimeString", align: "center" },
        { label: "审批结果", prop: "operResultName" },
        { label: "审批意见", prop: "operOpinion" }
    ]),

    // 国外供应商
    foreign: {
        // 供应商申请账号信息
        supplierAccountInfoBO4: Object.freeze([
            { label: $t('page.applyUsername.contentLabel.supName'), fieldName: "supName" }, // 供应商名称
            //{ label: $t('page.applyUsername.contentLabel.mobile'), fieldName: "registMobile" },   // 手机号
            { label: 'Username:', fieldName: "userName" },
            { label: 'Password:', fieldName: "password" },
            { label: 'Confirmed Password:', fieldName: "rePassword" },
        ]),
        supplierAccountInfoBO5: Object.freeze([
            { label: $t('page.applyUsername.contentLabel.contacts'), fieldName: "contactName" }, // 联系人
            { label: $t('page.applyUsername.contentLabel.contactsTel'), fieldName: "contactTel" }, //联系人固定电话
            { label: $t('page.applyUsername.contentLabel.contactsFax'), fieldName: "contactFax" }, // 联系人传真
            { label: $t('page.applyUsername.contentLabel.contactsMobile'), fieldName: "contactMobile" }, //联系人手机
            { label: $t('page.applyUsername.contentLabel.contactsEmail'), fieldName: "contactEmail" }, //联系人邮箱
        ]),
        supplierAccountInfoBO6: Object.freeze([
            { label: $t('page.applyUsername.contentLabel.reCompany'), fieldName: "recommendIndyName" }, //推荐单位
        ]),
        //供应商基本信息
        supplierBaseInfo: Object.freeze([
            { label: $t('page.supInfo.contentLabel.supName'), fieldName: "supName" }, // 供应商名称
            { label: $t('page.supInfo.contentLabel.abbreviation'), fieldName: "supShort" }, //供应商简称
            { label: $t('page.supInfo.contentLabel.supType'), fieldName: "supTypeNameComp" }, // 供应商类型
            { label: "CCCC internal enterprise:", fieldName: "isInIndyComp" },
            { label: $t('page.supInfo.contentLabel.country'), fieldName: "countryCode" }, // 供应商国别
            { label: "Company category:", fieldName: "companyCategoryName" },
            { label: "Social security number/Identification:", fieldName: "socialSecurityNumber" }, //境外社保号
            // { label: $t('page.supInfo.contentLabel.business'), fieldName: "regNum" },    // 营业执照
            { label: $t('page.supInfo.contentLabel.dutyParagraph'), fieldName: "taxCode" }, //税号
            { label: $t('page.supInfo.contentLabel.domicile'), fieldName: "homeAddr" }, // 住所
            { label: $t('page.supInfo.contentLabel.businessAddress'), fieldName: "officeAddr" }, // 办公地址
            { label: $t('page.supInfo.contentLabel.registeredCapital'), fieldName: "regCapl" }, // 注册资本
            { label: $t('page.supInfo.contentLabel.currency'), fieldName: "moneyTypeName" }, // 币种
            { label: $t('page.supInfo.contentLabel.businessScope'), fieldName: "busiScope" }, // 经营范围
            { label: $t('page.supInfo.contentLabel.foundingTime'), fieldName: "foundTime" }, // 成立时间
            { label: $t('page.supInfo.contentLabel.businessTerm'), fieldName: "businessValidDateStr" }, // 营业期限
            // { label: "初始推荐单位", fieldName: "recommendIndyName" },
            {
                label: $t('page.supInfo.contentLabel.organiza'),
                fieldName: "orgStructMarketNet"
            }, // 分支机构及联系方式
            { label: $t('page.supInfo.contentLabel.companyProfile'), fieldName: "companyProfile" }, // 公司简介

        ]),
        // 供应商联系信息
        supplierContact: Object.freeze([
            { label: $t('page.contactInfo.contentLabel.legalName'), fieldName: "legalContactName" }, // 法人代表姓名
            // { label: $t('page.contactInfo.contentLabel.market'), fieldName: "salesHeaderName" }, // 销售负责人
            { label: $t('page.contactInfo.contentLabel.marketMobile'), fieldName: "salesHeaderMobile" }, // 销售负责人手机
            { label: $t('page.contactInfo.contentLabel.marketTel'), fieldName: "salesHeaderTel" }, // 销售负责人固定电话
            { label: $t('page.contactInfo.contentLabel.marketFax'), fieldName: "salesHeaderFax" }, // 销售负责人传真
            { label: $t('page.contactInfo.contentLabel.marketEmail'), fieldName: "salesHeaderEmail" }, // 联系人E-mail
            { label: $t('page.contactInfo.contentLabel.web'), fieldName: "website" } // 公司网址
        ]),
        //财务信息
        financeInfo: Object.freeze([
            { label: $t('page.financeInfo.contentLabel.bankAccountName'), fieldName: "accountName" }, // 账户名
            { label: $t('page.financeInfo.contentLabel.bankAccount'), fieldName: "bankId" }, // 银行账号
            { label: $t('page.financeInfo.contentLabel.depositBank'), fieldName: "bankName" }, // 开户银行
            { label: $t('page.financeInfo.contentLabel.bankAddress'), fieldName: "accountBankAddr" }, //开户银行地址
            { label: $t('page.financeInfo.contentLabel.beneficiary'), fieldName: "payeeAddr" }, // 收款人地址
            { label: $t('page.financeInfo.contentLabel.swiftCode'), fieldName: "swiftCode" }, // 银行国际代码
            { label: $t('page.financeInfo.contentLabel.isWhether'), fieldName: "isAccpName", span: 24 } // 是否接受信用证付款
        ]),
        //产品信息
        productInfo: Object.freeze([
            { label: $t('page.productInfo.tableTh.productCode'), prop: "matcateryCode", align: "center" }, // 产品编码
            { label: $t('page.productInfo.tableTh.productName'), prop: "matcateryName", align: "center" }, // 产品名称
            { label: $t('page.productInfo.tableTh.productTrademark'), prop: "matTrademark", align: "center" }, // 产品商标
            { label: $t('page.productInfo.tableTh.remark'), prop: "prodinfoRemark", align: "center" } // 备注
        ]),
        //资质文件
        certificates: Object.freeze([
            { label: $t('page.qualificationFile.tableTh.name'), prop: "fileinfoTypeName", align: "center", slot: 'fileName' }, // 附件名称
            // { label: $t('page.qualificationFile.tableTh.size'), prop: "fileSize", slot: "size", align: "center" },   // 附件大小
            { label: $t('page.qualificationFile.tableTh.type'), prop: "fileTypeName", align: "center", slot: 'fileType' }, // 附件类型
            { label: $t('page.qualificationFile.tableTh.file'), prop: "fileName", align: "center" }, // 文件
            { label: $t('page.qualificationFile.tableTh.enclosureNotation'), prop: "fileDesc", align: "center", width: "220" }, // 附件说明
            { label: $t('page.qualificationFile.tableTh.operation'), prop: "d", slot: "opp", align: "center" } //操作
        ]),
    }
};